export default __webpack_public_path__ + "static/media/787 04222022_tn.fc59caa4.jpg";